import { AppVersion } from "../index";
const Logo = ({ displayPrefs, showVersion }) => {
	return (
		<>
			<svg id="logo" data-name="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 720 207.64" className={displayPrefs}>
				<path
					className="text-black"
					d="M730.34,26.2c-70.69-8.91-152.84-14-240.48-14C225,12.18,10.34,58.78,10.34,116.25c0,54,189.5,98.39,432,103.57-191.76-10.44-337.82-53.66-337.07-103.07C106.16,62,286.84,20.4,508.88,23.8c62.78,1,122.14,5.42,175,12.56A334.5,334.5,0,0,1,730.34,26.2Z"
					transform="translate(-10.34 -12.18)"
				/>
				<path className="text-crmls-blue" d="M252.23,122.56l-12,16.72h-40q-19.72,0-32.67-9.42t-12.95-23.65q0-14.25,12.79-23.08t32.83-8.82h52.9L238.07,91H200.36q-9.63,0-15.91,4.48T178.18,107q0,6.89,6.27,11.24t15.91,4.35Z" transform="translate(-10.34 -12.18)" />
				<path
					className="text-crmls-blue"
					d="M371.58,139.28H337.52l-22.84-16.4H282.41v16.4H258.83V106.15H324a27,27,0,0,0,9.86-1.54q4.92-2,4.92-5.93Q338.82,91,324,91H258.83l15.31-16.72h47.7q17.73,0,28.74,5.76Q362.94,86.66,363,98.82a18.14,18.14,0,0,1-5,12.39q-5,5.54-13.77,8.51Z"
					transform="translate(-10.34 -12.18)"
				/>
				<path
					className="text-crmls-blue"
					d="M514.71,139.44H489l-10-34.31L457.87,134.4a13.59,13.59,0,0,1-11.54,5.68,17.72,17.72,0,0,1-7.34-1.62,13.23,13.23,0,0,1-5.35-4.06l-21.29-29.27-9.86,34.31h-25.8L396.3,81.79a11.18,11.18,0,0,1,4.88-5.9,15.57,15.57,0,0,1,8.55-2.38q7.44,0,12.9,7.56l23.07,32.34,23.18-32.34q5.34-7.56,12.79-7.56a15.54,15.54,0,0,1,8.61,2.38,11.92,11.92,0,0,1,4.93,5.9Z"
					transform="translate(-10.34 -12.18)"
				/>
				<polygon className="text-crmls-blue" points="589.42 110.38 574.22 127.1 507.41 127.1 507.41 62.13 530.98 62.13 530.98 110.38 589.42 110.38" />
				<path
					className="text-crmls-blue"
					d="M689.91,74.31,674.83,91H621.42q-4.3,0-4.3,2.7t4.29,2.71h38.42q13.71,0,22.93,5.76,9.53,6.12,9.53,15.84t-9.63,15.57q-9,5.67-22.82,5.67H595.37l15.07-16.72h49.4a18.71,18.71,0,0,0,6.59-1.09c2.52-.9,3.77-2.13,3.77-3.7s-1.26-2.86-3.77-3.71a21.88,21.88,0,0,0-6.61-.9H621.37q-12.79,0-21.38-5-9.22-5.4-9.22-14.33T600,79.36q8.6-5.06,21.38-5Z"
					transform="translate(-10.34 -12.18)"
				/>
			</svg>
			{showVersion && <p className="text-xs text-secondary mt-1">Powered by CRMLS. Version {AppVersion}</p>}
		</>
	);
};

export default Logo;
